// test67
(67 && 0);
